import React, { useEffect } from 'react';
import { default as ReactSelect } from 'react-select';
import { components } from 'react-select';
import useAllTicketStore from './all_tickets/store';

function CreatedBy({selectedCreatedBy, setSelectedCreatedBy}) {

const {userData, fetchUserData} = useAllTicketStore();

useEffect(()=>{
  fetchUserData();
},[])


const optionList=userData?.map((item)=>{
  return {value:item.user.id, label:item.user.first_name}
})

  const Option = props => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  // Function triggered on selection
  function handleSelect(data) {
    setSelectedCreatedBy(data);
  }
  return (
    <>
      <h5 className="mt-3">CreatedBy</h5>
      <span
        className="d-inline-block"
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please selecet account(s)"
      >
        <ReactSelect
          options={optionList}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option,
          }}
          onChange={handleSelect}
          allowSelectAll={true}
          value={selectedCreatedBy}
        />
      </span>
    </>
  );
}

export default CreatedBy;
